import decompress from 'brotli/decompress';
/* eslint-disable */
function sliceBy(array, size) {
  const result = [];
  for (
    let startingIndex = 0, subArray = array.subarray(startingIndex, size);
    subArray.length > 0;
    startingIndex += size, subArray = array.subarray(startingIndex, startingIndex + size)
  ) {
    result.push(subArray);
  }
  return result;
}

const BrotliDecodeFromBase64String = {
  keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',

  /* will return a  Uint8Array type */
  decodeArrayBuffer(input) {
    const bytes = (input.length / 4) * 3;
    const ab = new ArrayBuffer(bytes);
    this.decode(input, ab);
    const b = decompress(new Uint8Array(ab));
    const string = new TextDecoder().decode(b);
    const a = sliceBy(b, 40000)
      .map((charArray) =>
        // String.fromCharCode.apply(null, charArray)
        new TextDecoder().decode(charArray)
      )
      .join('');
    return JSON.parse(a);
  },

  removePaddingChars(input) {
    const lkey = this.keyStr.indexOf(input.charAt(input.length - 1));
    if (lkey == 64) {
      return input.substring(0, input.length - 1);
    }
    return input;
  },

  decode(input, arrayBuffer) {
    // get last chars to see if are valid
    input = this.removePaddingChars(input);
    input = this.removePaddingChars(input);

    const bytes = parseInt((input.length / 4) * 3, 10);

    let uarray;
    let chr1;
    let chr2;
    let chr3;
    let enc1;
    let enc2;
    let enc3;
    let enc4;
    let i = 0;
    let j = 0;

    if (arrayBuffer) uarray = new Uint8Array(arrayBuffer);
    else uarray = new Uint8Array(bytes);

    // eslint-disable-next-line no-useless-escape
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

    for (i = 0; i < bytes; i += 3) {
      // get the 3 octects in 4 ascii chars
      enc1 = this.keyStr.indexOf(input.charAt(j++));
      enc2 = this.keyStr.indexOf(input.charAt(j++));
      enc3 = this.keyStr.indexOf(input.charAt(j++));
      enc4 = this.keyStr.indexOf(input.charAt(j++));

      // eslint-disable-next-line no-bitwise
      chr1 = (enc1 << 2) | (enc2 >> 4);
      // eslint-disable-next-line no-bitwise
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      // eslint-disable-next-line no-bitwise
      chr3 = ((enc3 & 3) << 6) | enc4;

      uarray[i] = chr1;
      if (enc3 !== 64) uarray[i + 1] = chr2;
      if (enc4 !== 64) uarray[i + 2] = chr3;
    }

    return uarray;
  },
};

export default BrotliDecodeFromBase64String;
